import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=707a327f&"
import script from "./CommentSection.vue?vue&type=script&lang=js&"
export * from "./CommentSection.vue?vue&type=script&lang=js&"
import style0 from "./CommentSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFileInput,VSelect})
